import React from 'react';
import { FaHtml5, FaCss3Alt, FaBootstrap, FaGithub } from "react-icons/fa";
import { SiTailwindcss, SiJavascript, SiReact, SiFirebase, SiNodedotjs, SiExpress, SiMongodb, SiAndroid, SiJava, SiCplusplus, SiMysql, SiTypescript, SiNextdotjs, SiNestjs, SiPrisma, SiVuedotjs } from "react-icons/si";
const About = () => {
    const technologies = [
        { id: 1, name: "HTML", icon: FaHtml5 },
        { id: 2, name: "CSS", icon: FaCss3Alt },
        { id: 3, name: "Bootstrap", icon: FaBootstrap },
        { id: 4, name: "Tailwind CSS", icon: SiTailwindcss },
        { id: 5, name: "JavaScript", icon: SiJavascript },
        { id: 5, name: "TypeScript", icon: SiTypescript },
        { id: 6, name: "React", icon: SiReact },
        { id: 6, name: "NextJs", icon: SiNextdotjs },
        { id: 4, name: "VueJs", icon: SiVuedotjs },
        { id: 7, name: "Firebase", icon: SiFirebase },
        { id: 8, name: "NodeJS", icon: SiNodedotjs },
        { id: 9, name: "ExpressjS", icon: SiExpress },
        { id: 9, name: "NestJs", icon: SiNestjs },
        { id: 10, name: "Mongo DB", icon: SiMongodb },
        { id: 9, name: "Prisma", icon: SiPrisma },
        { id: 11, name: "Android", icon: SiAndroid },
        { id: 12, name: "JAVA", icon: SiJava },
        { id: 13, name: "C++", icon: SiCplusplus },
        { id: 14, name: "MySQL", icon: SiMysql },
    ]
    return (
        <div className="full_wrapper about_part">
            <div className="container">
                <div className="row">
                    <div className=" col-12">
                        <div className="heading">
                            <h3 id="about">About</h3>
                        </div>
                        <div className="abt">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="pro_pic pro_content">
                                        <div>
                                            <img src="image/pro.jpg" alt="pro.jpg" />
                                            <h2 className='mt-4'><span>Hi! I am</span> Asaduzzaman</h2>
                                            <p className='mt-2 px-4 text-justify text-secondary'>I am Mohammad Asaduzzaman. Completed B. SC in Computer Science &amp; Engineering from independent university, Bangladesh in October, 2021. Now working with web development. Building website user friendly with frontend along with backend server side. Always try to keep myself up to date with modern web technologies.</p>
                                            <p className='text-justify text-secondary  px-4'>
                                            Currently I am working as Full Stack Developer at Lapasar Sdn Bhd, Malaysia remotely from June, 2022. My responsibility is building new features and write testable efficient code with maintaining  frontend and backend both of website along with database. I work here as remote employee from Bangladesh by maintaining their office time.
                                            </p>
                                            <p className='text-justify text-secondary  px-4'>
                                                As a developer, I have the ability to work with frontend modern technologies including
                                                backend. I am capable to build websites with the MERN stack. Also expert in building
                                                responsive website based on device screen size for better user experience.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="pro_content">

                                        <div className="skills">
                                            <h3>Skills</h3>
                                            <ul className="d-flex flex-column justify-content-center h-100">

                                                <li className="frnt-end">Front End</li>
                                                <li className="back-end">Back End</li>
                                                <li className="programming">problem solving</li>
                                                <li className="oop">OOP</li>
                                                <li className="android">Android App Development</li>
                                                <li className="google">Google-ing</li>
                                            </ul>

                                        </div>
                                        <div>
                                            <h3>Technologies</h3>
                                            <div className="skill d-flex flex-wrap gap-x-3  justify-content-center aling-items-center">
                                                {
                                                    technologies.map((tech) => <li key={tech.id} className=' d-flex flex-column  align-items-center justify-content-center gap-2'>

                                                        <tech.icon className='icon' />
                                                        <div><p>{tech.name}</p></div>
                                                    </li>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;